import { z } from 'zod';

export const performSqlQueryRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
    query: z.string().min(1, 'Query is required'),
  }),
  params: z.object({}).optional(),
});
export type PerformSqlQueryRequest = z.infer<typeof performSqlQueryRequest>;
export type PerformSqlQueryResponse = {
  result: string;
};

export const getPipesRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
  }),
  params: z.object({}).optional(),
});
export type GetPipesRequest = z.infer<typeof getPipesRequest>;
export type GetPipesResponse = {
  result: DatasourceInfo[];
};

export const getDatasourcesRequest = z.object({
  body: z.object({}).optional(),
  query: z.object({
    projectId: z.string().min(1, 'Project ID is required'),
  }),
  params: z.object({}).optional(),
});
export type GetDatasourcesRequest = z.infer<typeof getPipesRequest>;

export type DatasourceInfo = {
  name: string;
  columns: string[];
};

export type GetDatasourcesResponse = {
  result: DatasourceInfo[];
};
